import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Thankyou from './views/Thankyou.vue'
import SignupForm from './components/SignupForm'
import ExtendedForm from './components/ExtendedForm'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        { path: 'event/:event', name: 'event', component: SignupForm },
        { path: 'seminar/:event', name: 'extended-event', component: ExtendedForm }
      ]
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      component: Thankyou
    }
  ]
})
